import { defineStore } from 'pinia'
import Vue from 'vue'
export const usePortalStore = defineStore('portal', {
  state: () => ({
    portals: {}
  }),
  actions: {
    addPortal (target, id, renderElements) {
      if (!this.portals[target]) Vue.set(this.portals, target, {})
      Vue.set(this.portals[target], id, renderElements)
    },
    removePortal (target, id) {
      if (!this.portals[target]?.[id]) return
      Vue.delete(this.portals[target], id)
      if (!Object.keys(this.portals[target])?.length) Vue.delete(this.portals, target)
    }
  }
})
